window.UpdateDirectDebitConfirm = (function() {
    window.dataLayer = window.dataLayer || [];

    let self = {
        urls: {
            removeBankDetailSession: '/api/sitecore/UpdatePremiumBankDetails/RemoveBankDetailSession',
            redirectUrl: '/my-account/security'
        },
        func: {
            init: function() {
                self.func.bindings();
            },
            bindings: function() {
                $('#confirm-button').on('click', self.func.removeSessionAndRedirect);
            },
            removeSessionAndRedirect: function() {
                $.post(self.urls.removeBankDetailSession)
                    .done(function() {
                        window.location.href = self.urls.redirectUrl;
                    });

            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function() {
    // Initialize the form if the feature is enabled
    if ('confirm-section' === $('#confirm-section').data('feature')) {
        window.UpdateDirectDebitConfirm.Init();
    }
});
